/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ApiError400DefaultCodeEnum, ApiError500DefaultCodeEnum } from 'client-code/previews';
import { GuideError } from './GuideError';
import { ErrorTypes } from './ErrorTypes';

export class PreviewError extends GuideError {
    TAG: string = 'PreviewError';

    constructor(message: string, code: string) {
        super(code, message);
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ApiError400DefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.GUIDE_PREVIEW_APIGW_ERROR_C1301;
                this.type = ApiError400DefaultCodeEnum.ApigwError;
                break;
            case ApiError400DefaultCodeEnum.BadRequest:
                this.code = ErrorTypes.GUIDE_PREVIEW_BAD_REQUEST_C1302;
                this.type = ApiError400DefaultCodeEnum.BadRequest;
                break;
            case ApiError500DefaultCodeEnum.InternalServerError:
                this.code = ErrorTypes.GUIDE_PREVIEW_INTERNAL_SERVER_ERROR_C1303;
                this.type = ApiError500DefaultCodeEnum.InternalServerError;
                break;
            case ApiError500DefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.GUIDE_PREVIEW_APIGW_ERROR_C1304;
                this.type = ApiError500DefaultCodeEnum.ApigwError;
                break;
            default:
                this.code = ErrorTypes.GUIDE_PREVIEW_UNKNOWN_ERROR_C1399;
                this.type = 'PREVIEW_UNKNOWN_ERROR';
        }
    }
}
